import { EpimsBaseEntityDto } from './epim-base.dto';
export class DocumentSecurityDto extends EpimsBaseEntityDto {

    DocumentSecurityId: string;

    DocumentSecurityName: string;

   

}